import React, { useState } from 'react';
import { Form, Input, Button, Card, Row, Col, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store';
import { authAPI } from '../api/endpoints';
import './LoginPage.scss';

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuthStore();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await authAPI.login(values.username, values.password);
      const { token, user } = response.data;
      login(token, user);
      message.success('¡Bienvenido!');
      navigate('/');
    } catch (error) {
      message.error(error.response?.data?.error || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
        <Col xs={22} sm={16} md={12} lg={8}>
          <Card className="login-card">
            <div className="login-header">
              <h1>NOVA Billing</h1>
              <p>Sistema de Gestión de Facturas y Cobranzas</p>
            </div>

            <Form
              form={form}
              name="login"
              layout="vertical"
              onFinish={onFinish}
              autoComplete="off"
            >
              <Form.Item
                name="username"
                label="Usuario"
                rules={[{ required: true, message: 'Por favor ingresa tu usuario' }]}
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder="Usuario"
                  size="large"
                  disabled={loading}
                />
              </Form.Item>

              <Form.Item
                name="password"
                label="Contraseña"
                rules={[{ required: true, message: 'Por favor ingresa tu contraseña' }]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Contraseña"
                  size="large"
                  disabled={loading}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  size="large"
                  loading={loading}
                >
                  Iniciar Sesión
                </Button>
              </Form.Item>
            </Form>

            <div className="login-footer">
              <p>Versión 1.0.0 © 2025 NOVA Imaging</p>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default LoginPage;
